module.exports = __webpack_public_path__ + "static/img/vl0_service_manual.c8dc55d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/vl0_service_manual.png
// module id = ai1+
// module chunks = 0